<template>
  <div>
    <!-- 添加人员弹窗 -->
    <div class="to_view">
      <el-dialog
        title="添加人员"
        :visible.sync="dialogVisibleObj.addPersonnel"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <el-form
            :model="PersonnelForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="账号" prop="account">
              <el-input
                v-model.trim="PersonnelForm.account"
                placeholder="请输入账号"
                :maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="Name">
              <el-input
                v-model.trim="PersonnelForm.Name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model.trim="PersonnelForm.password"
                placeholder="请输入密码"
                show-password
              ></el-input>
              <p class="text1">密码长度为6-20位，需同时包含大小写字母和数字</p>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onCancel('ruleForm')">取 消</el-button>
          <el-button
            type="primary"
            :loading="sundflag"
            @click="submitForm('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="freeze_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.deletePopup"
        :close-on-click-modal="false"
      >
        <p v-if="deleteState == 0">
          确定要删除"{{ statePopupstatus.username }}"管理员吗?
        </p>
        <p v-if="deleteState == 1">此操作是批量删除管理员，是否确定？</p>
        <p v-if="deleteState == 2">当前未选择需操作的管理员，请选择</p>
        <p v-if="deleteState == 3">
          确定要重置用户名为"{{ statePopupstatus.username }}"
          的密码吗？重置后密码为:Wjy123456
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.deletePopup = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :loading="sundflag"
            @click="deleteBtn()"
            v-if="deleteState == 0"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="deleteArrBtn()"
            :loading="sundflag"
            v-if="deleteState == 1"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisibleObj.deletePopup = false"
            v-if="deleteState == 2"
            >确 定</el-button
          >
          <el-button
            type="primary"
            :loading="sundflag"
            @click="resetPaw()"
            v-if="deleteState == 3"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 编辑 -->
    <div class="editor_view">
      <el-dialog
        title="编辑人员"
        :visible.sync="dialogVisibleObj.editorPopup"
        :close-on-click-modal="false"
      >
        <div class="mianas">
          <el-form
            :model="editorForm"
            :rules="rules_text"
            ref="ruleForm2"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="账号： ">
              <div class="user_name">{{ statePopupstatus.username }}</div>
            </el-form-item>
            <el-form-item label="姓名： " prop="RealName">
              <el-input
                v-model.trim="statePopupstatus.RealName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码： " prop="PassWord">
              <el-input
                v-model.trim="editorForm.PassWord"
                placeholder="请输入密码"
                show-password
              ></el-input>
              <p class="text1">密码长度为6-20位，需同时包含大小写字母和数字</p>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editorCancel('ruleForm2')">取 消</el-button>
          <el-button type="primary" @click="editorBtn('ruleForm2')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import {
  addUser,
  deleteUser,
  deleteUserArr,
  updateUser,
  saveUserInit,
  batchDeleteUserInit,
  listRoles,
} from "@/api/permissions.js";
import md5 from "js-md5";
import { strongPass } from "@/utils/validata";
export default {
  props: ["statePopupstatus"],
  data() {
    return {
      dialogVisibleObj: {
        addPersonnel: false, // 添加弹窗
        deletePopup: false, // 删除弹窗
        editorPopup: false, // 编辑弹窗
      },
      deleteState: "",
      sundflag: false, // 添加防抖
      PersonnelForm: {
        // 表单
        account: "", // 账号
        Name: "", // 姓名
        password: "", // 密码
      },
      editorForm: {
        RealName: "",
        PassWord: "",
      },
      paw: 123456,
      flag: false, //是否禁用
      rules: {
        account: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
          {
            pattern: /\d{11}$/,
            message: "输入的值不是数字或长度不够11位",
          },
        ],
        Name: [{ required: true, message: "请输管理员姓名", trigger: "blur" }],
        password: [
          { required: true, validator: strongPass(this), trigger: "blur" },
        ],
      },
      rules_text: {
        PassWord: [{ validator: strongPass(this), trigger: "blur" }],
      },
    };
  },
  methods: {
    gitPersonnel() {
      this.dialogVisibleObj.addPersonnel = false;
    },
    // 取消
    onCancel(formName) {
      this.dialogVisibleObj.addPersonnel = false;
      this.$refs[formName].resetFields();
      this.PersonnelForm = {
        account: "", // 账号
        Name: "", // 姓名
        password: "", // 密码
      };
      this.$parent.getDataList();
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.sundflag = true;
          // 验证通过
          let res = {
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            hid: JSON.parse(loginvuex.state.hid),
            RealName: this.PersonnelForm.Name, // 姓名
            PassWord: md5(this.PersonnelForm.password), // 密码
            UserName: this.PersonnelForm.account, // 账号
          };
          let Data = await addUser(res);
          this.saveUserInit(Data.data.Data);
          //权限初始化功能
          if (Data.data.Status === 200) {
            this.$message.success("添加成功");
            this.dialogVisibleObj.addPersonnel = false;
            this.PersonnelForm.account = "";
            this.PersonnelForm.Name = "";
            this.PersonnelForm.password = "";
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
            this.$parent.getDataList();
          } else {
            this.$message.error("很抱歉" + Data.data.Data);
            this.sundflag = false;
          }
        } else {
          this.sundflag = false;
        }
      });
    },
    saveUserInit(userid) {
      let parmas = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hospital: JSON.parse(loginvuex.state.hid),
        role_code: "super_admin",
        user_id: userid,
      };
      saveUserInit(parmas);
    },
    batchDeleteUserInit(userarr) {
      let parmas = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hospital: JSON.parse(loginvuex.state.hid),
      };
      listRoles(parmas).then((res) => {
        return new Promise((resolve) => {
          resolve(res.data.Data[1].role_id);
        }).then((rolid) => {
          userarr.map((item) => {
            item["roleId"] = rolid;
          });
          let parmass = {
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            arr: userarr,
          };
          batchDeleteUserInit(parmass);
        });
      });
    },
    async deleteBtn() {
      console.log(this.statePopupstatus);
      this.sundflag = true;
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        UserID: this.statePopupstatus.userid,
      };
      const Data = await deleteUser(res);
      this.batchDeleteUserInit([{ userId: res.UserID }]);
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你,删除成功!",
          type: "success",
        });
        this.dialogVisibleObj.deletePopup = false;
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.$parent.getDataList();
      } else {
        this.sundflag = false;
        this.$message.error("删除失败!");
      }
      console.log(Data.status);
    },
    // 批量删除
    async deleteArrBtn() {
      //   let peopleId = [];
      //   this.$parent.multipleSelectionIds.map((item) => {
      //     peopleId.push(item.userid);
      //   });
      this.sundflag = true;
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        UserID: `[${this.$parent.multipleSelectionIds}]`,
      };
      const Data = await deleteUserArr(res);
      let newarr = this.$parent.multipleSelectionIds.map((item) => {
        let newobj = {};
        newobj.userId = item;
        return newobj;
      });
      this.batchDeleteUserInit(newarr);
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你,批量删除成功!",
          type: "success",
        });
        this.dialogVisibleObj.deletePopup = false;
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.$parent.getDataList();
      } else {
        this.sundflag = false;
        this.$message.error("删除失败!");
      }
      console.log(Data);
    },
    // 重置密码
    async resetPaw() {
      this.sundflag = true;
      let res = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: this.statePopupstatus.userid,
        PassWord: "c742afb9027ece245dde9438b0e5a489", // 该密码重置为Wjy123456
      };
      const Data = await updateUser(res);
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你,重置密码成功！",
          type: "success",
        });
        this.$parent.getDataList();
        this.dialogVisibleObj.deletePopup = false;
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
      } else {
        this.$message.error("重置失败!");
        this.sundflag = false;
      }
    },
    // 编辑
    async editorBtn(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = {
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            UserID: this.statePopupstatus.userid,
            hid: JSON.parse(loginvuex.state.hid),
            PassWord: md5(this.editorForm.PassWord),
            RealName: this.statePopupstatus.RealName,
          };
          let ress = {
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            UserID: this.statePopupstatus.userid,
            hid: JSON.parse(loginvuex.state.hid),
            RealName: this.statePopupstatus.RealName,
          };
          if (this.editorForm.PassWord == "") {
            const Data = await updateUser(ress);
            if (Data.status === 200) {
              this.$message({
                message: "恭喜你,编辑修改成功！",
                type: "success",
              });
              this.$parent.getDataList();
              this.dialogVisibleObj.editorPopup = false;
            } else {
              this.$message.error("修改失败!");
            }
          } else {
            const Data = await updateUser(res);
            if (Data.status === 200) {
              this.$message({
                message: "恭喜你,编辑修改成功！",
                type: "success",
              });
              this.editorForm.PassWord = "";
              this.$parent.getDataList();
              this.dialogVisibleObj.editorPopup = false;
            } else {
              this.$message.error("修改失败!");
            }
          }
        }
      });
    },
    // 编辑取消
    editorCancel(formName) {
      this.dialogVisibleObj.editorPopup = false;
      this.$refs[formName].resetFields();
      this.$parent.getDataList();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.to_view {
  ::v-deep .el-dialog {
    width: 568px;
    min-height: 408px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
  .mian {
    ::v-deep .el-form {
      flex-direction: column;
      .el-form-item__label {
        text-align: left;
        width: 80px !important;
      }
      .el-input__inner {
        width: 380px;
      }
      .el-form-item {
        margin-bottom: 40px !important;
      }
      .el-input__suffix {
        right: 50px !important;
        .el-input .el-input__clear {
          font-size: 16px;
        }
      }
    }
  }
}
.el-dialog__header {
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-bottom: 22px;
  span > button {
    width: 88px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    // margin-top: 38px;
  }
  span > button:nth-child(1) {
    background: #eeeeee;
    color: #aaaaaa;
  }
  span > button:nth-child(2) {
    margin-left: 50px;
  }
}
::v-deep .el-dialog__body {
  padding: 24px;
}
.freeze_view {
  ::v-deep .el-dialog {
    width: 400px;
    height: 240px;
    border-radius: 5px 5px 0px 0px;
  }
  p {
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
  }
  ::v-deep .el-dialog__footer span > button {
    margin-top: 24px;
  }
}
.editor_view {
  ::v-deep .el-dialog {
    width: 568px;
    min-height: 409px;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-form-item__label {
    width: 60px !important;
    text-align: left;
  }
  ::v-deep .el-form-item__content {
    margin-left: 60px !important;
  }
  .mianas {
    padding: 24px;
    ::v-deep .el-form {
      flex-direction: column;
    }
  }
  .user_name {
    margin-left: 10px;
  }
}
.text1 {
  color: #999999;
  margin-left: 6px;
}
</style>
